import { EventScheduleItem, SongModel } from "@/models/interfaces";
import { DocumentData, FirestoreDataConverter } from "firebase/firestore";
import { deepStripUndefined } from "@/utils/firestoreClean";

export const songConverter: FirestoreDataConverter<SongModel> = {
  toFirestore: (song: SongModel): DocumentData => {
    // Remove undefined fields before saving
    return deepStripUndefined(song);
  },
  fromFirestore: (snap) => snap.data() as SongModel,
};

export const scheduleConverter: FirestoreDataConverter<EventScheduleItem> = {
  toFirestore: (item: EventScheduleItem): DocumentData => {
    return deepStripUndefined(item);
  },
  fromFirestore: (snap) => snap.data() as EventScheduleItem,
};
